var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"indigo darken-3",attrs:{"app":""}},[_c('h1',{staticClass:"title bold text-center white--text",staticStyle:{"width":"100%"}},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }